import React from 'react';
import TablaEstadoCuenta1x500 from '../components/impuesto1x500/tablaEstadoCuenta';

function estadoCuenta1x500() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaEstadoCuenta1x500 />
      </div>
  );
}

export default estadoCuenta1x500;




// WEBPACK FOOTER //
// ./src/pages/estadocuenta1x500.js